import axios from '@/libs/api.request'

const materialCollectService = {
  uploadCollectInfo (url, type) {
    return axios.request({
      url: '/info/modify/upload/collect/info',
      data: {
        url: url,
        type: type
      },
      method: 'POST'
    })
  },
  getCollectInfo () {
    return axios.request({
      url: '/info/query/personal/file',
      method: 'GET'
    })
  }
}

export default materialCollectService
